import appSettings from 'wanderu-config';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';
import {
    makeQueryString,
} from 'wanderu-utils';

const logger = Logger.getLogger('BookButton');

const EXTERNAL_SEARCH_DELIM = ';';
const EXT_SEARCH_DIRECTION_DELIM = '||';

function buildBookingButtonUrl(opts) {
    const {
        checkoutData,
        currency,
        locale,
        tripIds,
        tripItineraryId,
        searchQueries,
    } = opts;

    const requiredValues = [
        {
            name: 'checkoutData',
            value: checkoutData,
        },
        {
            name: 'currency',
            value: currency,
        },
        {
            name: 'locale',
            value: locale,
        },
        {
            name: 'tripIds',
            value: tripIds,
        },
        {
            name: 'tripItineraryId',
            value: tripItineraryId,
        },
    ];

    const missingRequiredValues = requiredValues.filter(
        (requiredProp) => requiredProp.value === undefined,
    );

    if (missingRequiredValues.length) {
        missingRequiredValues.map((value) => {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            return logger.error('buildBookingButtonUrl', `${value.name} is required`, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });
        });

        return null;
    }

    const queries = {
        cur: currency,
        extSearchLcTokens: tripIds.map((id) => checkoutData[id] && checkoutData[id].token)
            .filter(Boolean)
            .join(EXTERNAL_SEARCH_DELIM),
        extSearchTripItin: tripItineraryId,
        selectedFares: tripIds.map((id) => checkoutData[id]?.selectedFare)
            .join(EXT_SEARCH_DIRECTION_DELIM),
        ...searchQueries,
    };

    return `/checkout/${makeQueryString(queries)}`;
}

export {
    buildBookingButtonUrl,
};
